import Styles from "./HeroImage.module.scss"
import Image from "next/image"

export default function HeroImage({ alt, url }) {
  return (
    <div
      className={Styles.HeroImageWrapper}
      style={{
        width: "100%",
        height: "350px",
        backgroundImage: "",
        backgroundSize: "100%",
        backgroundPosition: "center",
        borderRadius: "35px",
        maxWidth: "600px",
      }}
    >
      <div className="absolute inset-0 flex items-center justify-center">
        <Image
          src={`/assets/${url}.webp`}
          style={{ borderRadius: "35px" }}
          width={350}
          height={250}
          alt={alt}
        />
      </div>
    </div>
  )
}
